module.exports = __webpack_public_path__ + "a045126aa473b2fb9bd99fc78b524909.png";